/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Memberships {
    angular.module("meevo.plugins.memberships", []);
}